import React, { useState } from 'react';
import './Sendinvite.css';
import cancel from '../../assets/cancel.png';
import { useNavigate } from 'react-router-dom';

const Sendinvite = ({setOption, setShowOption}) => {
  const navigate = useNavigate();
  const [additionalFields, setAdditionalFields] = useState([]);

  const handleAddField = () => {
    const newField = {
      label: 'New Field',
      placeholder: 'Enter value',
    };
    setAdditionalFields([...additionalFields, newField]);
  };

  const handleSendInvite = () => {
    navigate('/invitesent'); // Navigate to Invitesent page
  };

  const handleClosePopup = () => {
    // navigate('/singleemployee'); // Navigate to Singleemployee page
  };

  return (
    <div className="container-sendinvite">
      <div className="header-main">
        <div className="header-text">
          <h2 className="">Send Invite</h2>
          <p className="description">Fill out the form below to send an employee invite.</p>
        </div>
        <div className='close-icon' onClick={() => (setShowOption(false), setOption('option1'))}>
          <img src={cancel} alt="cancel icon" />
        </div>
      </div>

      <div className="form-fields">
        <div className="field-group">
          <div className="name-fields">
            <div className="field-group">
              <label className="label">First Name</label>
              <input type="text" className="form-field" placeholder="Enter first name" />
            </div>
            <div className="field-group" style={{ marginLeft: '10px' }}>
              <label className="label">Last Name</label>
              <input type="text" className="form-field" placeholder="Enter last name" />
            </div>
          </div>
          <div className="field-group">
            <label className="label">Email</label>
            <input type="email" className="form-field" placeholder="Enter email" />
          </div>
          <div className="field-group">
            <label className="label">Phone Number</label>
            <input type="tel" className="form-field" placeholder="Enter phone number" />
          </div>
          <div className="field-group">
            <label className="label">Job Role</label>
            <select className="form-field">
              <option value="select-role">Select role</option>
                <option value="role1">Marketing</option>
                <option value="role2">Information technology</option>
                <option value="role3">Customer support</option>
                <option value="role4">Other</option>
            </select>
          </div>
          <div className="field-group">
            <label className="label">Date of Employment</label>
            <input type="date" className="form-field" />
          </div>

          {additionalFields.map((field, index) => (
            <div className="field-group additional-field" key={index}>
              <label className="label">{field.label}</label>
              <input type="text" className="form-field" placeholder={field.placeholder} />
            </div>
          ))}

          {/* Centered button with dotted border */}
          <div className="centered-button">
            <button className="add-field-button">
              <span className="dot-dot">..</span> Add another employee detail
            </button>
          </div>
        </div>
      </div>

      <button className="submit-button" onClick={() => setOption('option3')}>
        Send Employee Invite
      </button>
    </div>
  );
};

export default Sendinvite;